/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClockClose = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 4v2a9.984 9.984 0 0 1 8-4c5.255 0 9.563 4.053 9.969 9.203l-2.07 2.069A8 8 0 0 0 5.07 8H8v2H2V4h2zm9.272 15.9A8 8 0 0 1 4 12H2c0 5.254 4.053 9.562 9.203 9.969l2.069-2.07z"
        fill="currentcolor"
      />
      <path
        d="M11 11V6h2v7H8v-2h3zm3.5 4.914 2.793 2.793L14.5 21.5l1.414 1.414 2.793-2.793 2.793 2.793 1.414-1.414-2.793-2.793 2.793-2.793L21.5 14.5l-2.793 2.793-2.793-2.793-1.414 1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgClockClose as ClockClose };
